/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findPersonalizedContentSF = (queryName = 'personalizedContent') => (
    gql`query ${queryName} (
        $brand: String!
        $environment: String!
        $user: UserSF!
        $targeting: TargetingSF!
        $userAttributes: [UserAttributesSF]
        $isHoldoutEligible: Boolean!
        $resolveIdentity: Boolean!
    ) {
        contentSF(
            brand: $brand,
            environment: $environment,
            user: $user,
            targeting: $targeting,
            userAttributes: $userAttributes,
            isHoldoutEligible: $isHoldoutEligible
            resolveIdentity: $resolveIdentity
        ) {
            campaign
            content
            isHoldOut
        }
    }`
);

export default findPersonalizedContentSF;
